<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="500")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
        @click="showAlert"
        class="mr-2"
        slot="activator" 
        small 
        title='Withdraw' 
        color="red" 
        v-bind="attrs"
        v-on="on"
      ) cancel

    v-card
      v-card-title(class="headline grey lighten-3 mb-3") Withdraw Payment Voucher
      div(class="pl-6")
        span.red--text *
        b(class="pt-3" style="font-size: 14px;") {{currentStatusText}}
      p(class="pl-6 pt-3" style="font-size: 14px;") 
        span.red--text *
        | Leave a comment for the Payment Voucher
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            v-textarea(
              v-model="comment"
              filled
              label="Description"
              counter="150"
              :rules="[rules.length(150)]"
            )
            
      v-card-actions.pb-5
        v-spacer
        v-btn(
          depressed
          @click="dialog = false"
          class="pl-4 pr-4"
        )
          | Close

        v-btn(
          :disabled="!isInputValid" 
          color="blue-secondary" 
          depressed 
          @click="submit"
          class="pl-4 pr-4"
        ) Submit

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";
import * as i18n from "../data/i18n.json";
import { mapState } from "vuex";
export default {
  name: 'WithdrawDialogPV',
  props: {
    imId: String,
    im: Object,
    creator: Boolean
  },
  data: () => ({
    dialog: false,
    currentStatusText: '',
    duplicate: false,
    i18n: i18n.default,
    overlay: false,
    comment: '',
    rules: {
      length: len => v => (v || '').length <= len || `Comment must be less than 150 characters`,
    },
  }),
  computed: {
    isInputValid() {
      return this.comment != '' && this.comment.length <= 150
    }
  },
  methods: {
    showAlert() {
      setTimeout(()=> {
        this.currentStatusText = ''
        this.dialog = false
        
        // If we have data in prop, use it directly to avoid API call
        if (this.im && this.im.imType == 8) {
          this.processPVData(this.im)
          return
        }
        
        // Validate imId before making API call
        if (!this.imId) {
          // Try to use im prop as fallback
          if (this.im) {
            this.processPVData(this.im)
          } else {
            this.$toasted.error('Payment Voucher ID is missing', { icon: 'error' });
          }
          return
        }
        
        // Otherwise, fetch from API
        let token = localStorage.getItem("token");
        axios({
            method: "get",
            url: process.env.VUE_APP_API_OLD+`/api/pv/${this.imId}`,
            headers: { Authorization: `Bearer ${token}` },
        }).then(res => {
            console.log(res.data)
            let memoDTL = res.data
            this.processPVData(memoDTL)
        }).catch((e)=> {
          console.log(e)
          // If error and we have im prop, try using it
          if (this.im) {
            this.processPVData(this.im)
          } else {
            const errorMsg = (e.response && e.response.data && e.response.data.message) || e.message || "Failed to load Payment Voucher details"
            this.$toasted.error(errorMsg, { icon: 'error' });
          }
        })
      
      },10)
    },
    processPVData(memoDTL) {
      // Handle both array response and single object
      if (Array.isArray(memoDTL) && memoDTL.length > 0) {
        memoDTL = memoDTL[0]
      }
      
      let status = this.i18n.status[memoDTL.imStatus].name
      // PREVENT REJECTED, FULLY APPROVED, WD MEMO FOR BEING RE-WD
      if ([4, 9, 5, 8].includes(memoDTL.imStatus)) {
        this.currentStatusText = `This Payment Voucher Already Been ${status}`
        this.$toasted.error(this.currentStatusText, { icon: 'error' });
        return
      } else {
        // CHECK IF CREATOR
        const pvCreatorId = memoDTL.userId || (memoDTL.imUser && memoDTL.imUser._id) || (memoDTL.imUser && memoDTL.imUser.id)
        if (pvCreatorId == this.$store.state.dataUsers.user._id) {
          // CHECK IF PV DRAFT
          if (memoDTL.imStatus == 1) this.currentStatusText = `This Payment Voucher Currently "${status}"`
          // CHECK IF PV REVIEWED BY SOME1
          else if (memoDTL.imStatus == 3) {
            const returnData = memoDTL.imReturn && memoDTL.imReturn.length > 0 ? memoDTL.imReturn[memoDTL.imReturn.length-1] : null
            if (returnData) {
              this.currentStatusText = `This Payment Voucher Currently "${status}" By ${memoDTL.imUseAlias ? returnData.alias : returnData.name}`
            } else {
              this.currentStatusText = `This Payment Voucher Currently "${status}"`
            }
          }
          // CHECK IF PV ON GOING
          else if (memoDTL.imStatus != 1 && memoDTL.imStatus != 3) {
            if (memoDTL.imWorkflow) {
              for (let i in memoDTL.imWorkflow) {
                if (memoDTL.imWorkflow[i].status == 9) {
                  this.currentStatusText = `This Payment Voucher Currently "${status}" By ${memoDTL.imUseAlias ? memoDTL.imWorkflow[i].alias:  memoDTL.imWorkflow[i].name}`
                  break;
                }
              }
            }
          }
        // THIS ELSE FOR APPROVER THAT ABLE TO WD PV #SOMEHOW 
        } else {
          // CHECK IF PV REVIEWED BY SOME1
          if (memoDTL.imStatus == 3) {
            const returnData = memoDTL.imReturn && memoDTL.imReturn.length > 0 ? memoDTL.imReturn[memoDTL.imReturn.length-1] : null
            if (returnData) {
              this.currentStatusText = `This Payment Voucher Currently "${status}" By ${memoDTL.imUseAlias ? returnData.alias : returnData.name}`
            } else {
              this.currentStatusText = `This Payment Voucher Currently "${status}"`
            }
          }
          if (memoDTL.imStatus == 4) this.currentStatusText = "Failed, Payment Voucher has been processed"
          if (memoDTL.imStatus == 5) this.currentStatusText = "Failed, Payment Voucher has been processed"
          if (memoDTL.imStatus == 8) this.currentStatusText = "Failed, Payment Voucher has been processed"
          // CHECK IF PV ON GOING
          else if (memoDTL.imStatus != 1 && memoDTL.imStatus != 3) {
            if (memoDTL.imWorkflow) {
              for (let i in memoDTL.imWorkflow) {
                if (memoDTL.imWorkflow[i].status == 9) {
                  this.currentStatusText = `This Payment Voucher Currently "${status}" By ${memoDTL.imWorkflow[i].name}`
                  break;
                }
              }
            }
            this.$toasted.error(this.currentStatusText, { icon: 'error' });
            return
          }
        }
      }
      this.dialog = true
    },
    async submit() {

      try {
        // Use data from prop if available, otherwise fetch from API
        let memoDTL = this.im
        if (!memoDTL || !memoDTL.imType) {
          // Validate imId before making API call
          if (!this.imId) {
            this.$toasted.error('Payment Voucher ID is missing', { icon: 'error' });
            return
          }
          
          let token = localStorage.getItem("token");
          const d = await axios({
              method: "get",
              url: process.env.VUE_APP_API_OLD+`/api/pv/${this.imId}`,
              headers: { Authorization: `Bearer ${token}` },
          })
          memoDTL = d.data
        }
        
        // IS NOT A CREATOR AND CURRENTLY NOT NEED REVIEW (CAN BE WD BY SPECIFIC APPV)
        const pvCreatorId = memoDTL.userId || (memoDTL.imUser && memoDTL.imUser._id) || (memoDTL.imUser && memoDTL.imUser.id)
        if (pvCreatorId != this.$store.state.dataUsers.user._id && memoDTL.imStatus != 3) {
          this.$toasted.error("Failed, Payment Voucher has been processed", { icon : 'check_circle'});
          return
        }
      
      // Use correct payload format for withdrawPV endpoint
      // withdrawPV expects: { imId or _id, reason }
      // Try to get ID from memoDTL if imId is not available
      const pvId = this.imId || (memoDTL && memoDTL._id)
      
      // Validate imId before making request
      if (!pvId) {
        this.$toasted.error('Payment Voucher ID is missing', { icon: 'error' });
        return
      }
      
      const payload = {
        imId: pvId,
        reason: this.comment
      }
      
      let token = localStorage.getItem("token");
      axios.put(process.env.VUE_APP_API_OLD+`/api/withdraw/pv`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then((res) => {
            this.$toasted.error("Payment Voucher has been success withdraw", { icon : 'check_circle'});
            this.dialog = false
            location.reload();

        }).catch((err) => {
          console.error('Withdraw PV error:', err);
          if (err.response && err.response.data && err.response.data.message) {
            this.$toasted.error(err.response.data.message, { icon: 'error' });
          } else if (err.response && err.response.data && err.response.data.error) {
            this.$toasted.error(err.response.data.error, { icon: 'error' });
          } else {
            this.$toasted.error(err.message || 'Failed to withdraw Payment Voucher', { icon: 'error' });
          }
        });
      } catch (e) {
        this.$toasted.error(e.message || e, { icon: 'error' });
      }

    }
  }
};
</script>
<style scoped>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #D42A2A !important;
    }
</style>
